import PrzekazyTable from "./table";

const Przekazy = () => {
	return (
		<>
			<PrzekazyTable />
		</>
	);
};

export default Przekazy;
